document.addEventListener("DOMContentLoaded", () => {
  let mobileMenuButton = document.querySelector(".mobile-menu-button button");

  mobileMenuButton.addEventListener("click", () => {
    setTimeout(() => {
      const element = document.querySelector(".header-sidebar__collapsible-panel");

      if (!element.hasAttribute("aria-activedescendant")) {
        element.setAttribute("aria-activedescendant", "header-panel-1");
      }
      
      if (!element.hasAttribute("open")) {
        element.setAttribute("open", "");
      }

      document.getElementById("header-panel-1").removeAttribute("hidden");
    }, 200);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const collectionDescriptionToggle = document.querySelector(
    ".collection-description-toggle"
  );
      if(collectionDescriptionToggle){
  collectionDescriptionToggle.addEventListener("click", () => {
    collectionDescriptionToggle.previousElementSibling.classList.toggle("open");
    collectionDescriptionToggle.textContent =
      collectionDescriptionToggle.previousElementSibling.classList.contains(
        "open"
      )
        ? "Daha Az"
        : "Daha Fazla";
  });}
});
